import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './styles/buttons.scss';
import reportWebVitals from './reportWebVitals';
import { LanguageProvider } from './components/LanguageSwitcher/LanguageContext';
import { loadAnalyticsIfAllowed } from './lib/track';

// CSS entry animations hide their element until they play (fill-mode: both),
// and they do not play in a tab that loaded in the background. Those rules are
// scoped to `.anim-ready`, which is only set when the page is actually being
// looked at — so content is never left stranded at opacity 0.
if (document.visibilityState === 'visible') {
  document.documentElement.classList.add('anim-ready');
}

// Vercel Web Analytics, script-tag install (no npm package). The stub queues
// events until the script loads; src/lib/track.js loads the script only when
// the visitor's "analytics" cookie category is on, and reports conversions.
window.va = window.va || function () { (window.vaq = window.vaq || []).push(arguments); };
loadAnalyticsIfAllowed();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageProvider> 
    <App />
    </LanguageProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
